import { createPrefixedConstants } from 'app/common/CommonUtils';

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_SHARED_ZAPS = 'GET_SHARED_ZAPS';
export const GET_ZAP_TEMPLATES = 'GET_ZAP_TEMPLATES';
export const GET_ZAPS = 'GET_ZAPS';
export const GET_ZAPS_DONE = 'GET_ZAPS_DONE';
export const GET_ZAPS_ERROR = 'GET_ZAPS_ERROR';
export const INITIATING = 'INITIATING';
export const PREFILL_ZAPS = 'PREFILL_ZAPS';
export const RECEIVE_ACCOUNTS = 'RECEIVE_ACCOUNTS';
export const RECEIVE_ZAP_TEMPLATES = 'RECEIVE_ZAP_TEMPLATES';
export const RECEIVE_ZAPS = 'RECEIVE_ZAPS';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const UPDATE_ZAP_TEMPLATES = 'UPDATE_ZAP_TEMPLATES';
export const UPDATE_ZAPS = 'UPDATE_ZAPS';
export const ZAP_ATTEMPT = 'ZAP_ATTEMPT';
export const ZAP_ERROR = 'ZAP_ERROR';
export const ZAP_RESET_AFTER_ERROR = 'ZAP_RESET_AFTER_ERROR';
export const ZAP_RESET_AFTER_SUCCESS = 'ZAP_RESET_AFTER_SUCCESS';
export const ZAP_SUCCESS = 'ZAP_SUCCESS';
export const ZAP_TEMPLATES = 'ZAP_TEMPLATES';
export const ZAP_TOGGLE = 'ZAP_TOGGLE';
export const ZAP_UPDATE = 'ZAP_UPDATE';
export const ZAPS = 'ZAPS';

export const actionTypes = createPrefixedConstants(
  'push',
  `
    INITIALIZE
    GET_ACCOUNTS
    GET_SHARED_ZAPS
    GET_ZAP_TEMPLATES
    GET_ZAPS
    GET_ZAPS_DONE
    GET_ZAPS_ERROR
    PREFILL_ZAPS
    RECEIVE_ACCOUNTS
    RECEIVE_ZAP_TEMPLATES
    RECEIVE_ZAPS
    UNAUTHORIZED
    UPDATE_ZAP_TEMPLATES
    UPDATE_ZAPS
    ZAP_ATTEMPT
    ZAP_ERROR
    ZAP_RESET_AFTER_ERROR
    ZAP_RESET_AFTER_SUCCESS
    ZAP_SUCCESS
    ZAP_TEMPLATES
    ZAP_TOGGLE
    ZAP_UPDATE
  `
);

export default actionTypes;
